import { c as _c } from "react/compiler-runtime";
import { Badge, Button, HStack, Input, SegmentGroup, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';
export type PaywallTermOption = {
  id: string;
  label: string;
  savingsLabel?: string;
};
export type PaywallOfferControlsProps = {
  terms: PaywallTermOption[];
  selectedTermId: string;
  onTermChange: (termId: string) => void;
  appliedCouponCode?: string | null;
  couponError?: string | null;
  couponIsApplying?: boolean;
  onApplyCoupon?: (code: string) => void;
  onRemoveCoupon?: () => void;
  /** `center` sits the term picker and code link together under a centered heading. */
  align?: 'start' | 'center';
};

/** Controlled selections. Only a caller's resolved coupon is displayed as applied. */
export const PaywallOfferControls = t0 => {
  const $ = _c(20);
  const {
    align: t1,
    appliedCouponCode,
    couponError,
    couponIsApplying: t2,
    onApplyCoupon,
    onRemoveCoupon,
    onTermChange,
    selectedTermId,
    terms
  } = t0;
  const align = t1 === undefined ? "start" : t1;
  const couponIsApplying = t2 === undefined ? false : t2;
  const [draftCode, setDraftCode] = useState("");
  const [codeRequested, setCodeRequested] = useState(false);
  const codeOpen = codeRequested || Boolean(couponError) || couponIsApplying;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: "stretch",
      sm: "center"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: "column",
      sm: "row"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = align === "center" ? "center" : "space-between";
  let t6;
  if ($[2] !== onTermChange || $[3] !== selectedTermId || $[4] !== terms) {
    t6 = terms.length > 1 ? <SegmentGroup.Root aria-label="Billing period" minW={0} size="lg" value={selectedTermId} w={{
      base: "full",
      sm: "auto"
    }} onValueChange={details => {
      if (details.value) {
        onTermChange(details.value);
      }
    }}><SegmentGroup.Indicator />{terms.map(_temp)}</SegmentGroup.Root> : null;
    $[2] = onTermChange;
    $[3] = selectedTermId;
    $[4] = terms;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== align || $[7] !== appliedCouponCode || $[8] !== codeOpen || $[9] !== codeRequested || $[10] !== couponError || $[11] !== couponIsApplying || $[12] !== draftCode || $[13] !== onApplyCoupon || $[14] !== onRemoveCoupon) {
    t7 = onApplyCoupon ? <Stack align={align === "center" ? "center" : undefined} gap={2}>{appliedCouponCode || codeOpen ? <Text color="fg.muted" textStyle="label2xs">Promotion code</Text> : null}{appliedCouponCode ? <HStack gap={2} wrap="wrap"><Badge colorPalette="green" variant="surface">Code {appliedCouponCode} applied</Badge>{onRemoveCoupon ? <Button size="xs" variant="ghost" onClick={onRemoveCoupon}>Remove code</Button> : null}</HStack> : !codeOpen ? <Button _hover={{
        color: "fg",
        textDecorationColor: "currentColor"
      }} alignSelf={align === "center" ? "center" : "flex-start"} color="fg.muted" h="auto" px={0} size="xs" textDecoration="underline" textDecorationColor="border.emphasized" textUnderlineOffset="3px" variant="plain" onClick={() => setCodeRequested(true)}>Have a promotion code?</Button> : <HStack align="start" as="form" gap={2} justify={align === "center" ? "center" : undefined} wrap="wrap" onSubmit={event => {
        event.preventDefault();
        const code = draftCode.trim();
        if (code) {
          onApplyCoupon(code);
        }
      }}><Input aria-invalid={Boolean(couponError)} aria-label="Promotion code" autoFocus={codeRequested} maxW="full" placeholder="Enter code" size="sm" value={draftCode} w="15rem" onChange={event_0 => setDraftCode(event_0.target.value)} /><Button disabled={!draftCode.trim() || couponIsApplying} size="sm" type="submit" variant="outline">{couponIsApplying ? "Checking\u2026" : "Apply"}</Button></HStack>}{couponError ? <Text color="red.fg" role="alert" textStyle="xs">{couponError}</Text> : null}</Stack> : null;
    $[6] = align;
    $[7] = appliedCouponCode;
    $[8] = codeOpen;
    $[9] = codeRequested;
    $[10] = couponError;
    $[11] = couponIsApplying;
    $[12] = draftCode;
    $[13] = onApplyCoupon;
    $[14] = onRemoveCoupon;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <Stack align={t3} columnGap={6} direction={t4} justify={t5} rowGap={3} wrap="wrap">{t6}{t7}</Stack>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp(term) {
  return <SegmentGroup.Item key={term.id} flex={{
    base: 1,
    sm: "initial"
  }} h="auto" minH={11} px={{
    base: 2,
    sm: 4
  }} py={1.5} value={term.id}><SegmentGroup.ItemText><Stack align="center" gap={0}><Text fontWeight="medium" textStyle="sm">{term.label}</Text>{term.savingsLabel ? <Text color="green.fg" fontWeight="medium" lineHeight="short" textStyle="2xs">{term.savingsLabel}</Text> : null}</Stack></SegmentGroup.ItemText><SegmentGroup.ItemHiddenInput /></SegmentGroup.Item>;
}